<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`"></div>
		</div>
		<div class="container">
			<div class="nav">
				<a-breadcrumb separator=">">
					<a-breadcrumb-item>
						<router-link :to="{path:'/',query:{menuPosition:'1481846823343697922'}}">首页</router-link>
					</a-breadcrumb-item>
					<a-breadcrumb-item>
						<router-link to="#">业务介绍</router-link>
					</a-breadcrumb-item>
					<a-breadcrumb-item>
						<router-link to="#">{{info.title}}</router-link>
					</a-breadcrumb-item>
				</a-breadcrumb>
				<div class="reback" @click="reback">
					返回
					<a-icon type="rollback" />
				</div>
			</div>
			<div class="info-box">
				<div class="title">{{info.title}}</div>
				<div class="contents" v-html="info.businessIntroduce"></div>
			</div>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	export default {
		components: {
			BaseNav,
			BaseFooter,
		},
		data() {
			return {
				id: "",
				info: {},
				loading: true,
				headBg: "",
			}
		},
		created() {
			document.title = "雄安股权交易所-业务详情";
		},
		mounted() {
			this.id = this.$route.query.business;
			this.getHeadBg();
			this.getInfo();
		},
		methods: {
			reback(){
				window.history.go(-1);
			},
			getInfo(){
				this.$request({
					url:this.$api.home.queryBusinessDetails,
					data:{businessId:this.id}
				}).then((res)=>{
					console.log(res.data.result);
					this.info = res.data.result;
				})
			},
			getHeadBg() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: 2,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			}
		}
	}
</script>

<style scoped>
	.info-box{
		min-height: 500px;
		background-color: white;
		margin-top: 30px;
		margin-bottom: 30px;
		border-radius: 10px;
		padding:30px;
	}
	
	.nav {
		width: 1200px;
		height: 100px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		margin-top: -50px;
		padding: 40px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
	}
	
	.info-box .title{
		font-size: 30px;
		font-weight: bold;
		text-align: center;
		border-bottom: 1px solid #ededed;
		padding-bottom: 30px;
	}
	
	.info-box .contents{
		margin-top: 30px;
	}
	
	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 115px;
	}

	.head-bg p {
		font-size: 24px;
	}
	
	.bg-gray {
		background: #F6F7FC;
	}
</style>



// WEBPACK FOOTER //
// src/pages/business/business.vue